module.exports = __webpack_public_path__ + "fonts/BridgestoneType-Bold.d23489c4.woff2";